import { useMemo } from 'react';
import useUrl from 'utils/hooks/useUrl';
import EnumParams from 'utils/legacy/paths/params';
import EnumSimPage from 'utils/legacy/paths/simPage';

interface UseSimUrlProps {
  simDetailBaseUrl: string;
  orgId?: OrgId;
  simId?: SimId;
  batchJobId?: string;
  subpage?: EnumSimPage;
}

const useSimUrl = ({ simDetailBaseUrl, orgId, simId, batchJobId, subpage }: UseSimUrlProps) => {
  const replacers = useMemo(
    () => [
      { placeholder: EnumParams.simId, value: simId?.toString() ?? '' },
      { placeholder: EnumParams.orgId, value: orgId?.toString() ?? '' },
      { placeholder: EnumParams.batchJobId, value: batchJobId ?? '' },
    ],
    [batchJobId, orgId, simId]
  );
  return useUrl({
    url: subpage ? `${simDetailBaseUrl}/${subpage}` : simDetailBaseUrl,
    replacers,
  });
};
export default useSimUrl;
